import './components/resize';
import './components/form-alert';
import './components/form-fields';

// Rimozione classe no-js
document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/, 'js');